import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { InviteMemberModalProps } from "@/types";
import { Modal } from "@/components/common";
import InviteMemberInputs from "./InviteMemberInputs.vue";


/**
 * A modal for inviting project members.
 */
const __default__ = {
  name: "InviteMemberModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    email: {},
    entity: {}
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    title: "Share Project",
    open: props.open,
    size: "md",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      (props.open)
        ? (_openBlock(), _createBlock(InviteMemberInputs, {
            key: 0,
            entity: props.entity,
            email: props.email,
            onSave: _cache[0] || (_cache[0] = ($event: any) => (emit('submit')))
          }, null, 8, ["entity", "email"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})